<template>
  <div class="form-group" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <select
        v-model="select"
        :class="{'is-invalid': v.$error}"
        :disabled="disabled"
        class="form-control"
        :id="idComputed"
        >
        <option disabled value="">{{options.disabledOption}}</option>
        <template v-if="typeof options.content[0] !== 'object' ">
          <option v-for="(option, index) of options.content" :key="index">{{option}}</option>
        </template>
        <template v-if="typeof options.content[0] === 'object'">
          <option v-for="(option, index) of options.content" :key="index" :value="option.value">{{option.text}}</option>
        </template>
      </select>
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    /**
    * Select options
    */
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    select: {
      get () {
        return this.value
      },
      set (value) {
        if (Object.entries(this.v).length) {
          this.v.$touch()
        }
        this.$emit('input', value)
      }
    }
  }
}
</script>
